import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-admin';

const Title = ({ translate, record = {} }) => (
    <span>
        { translate('resources.courses.name', { smart_count: 1 }) }: { `${record.ClassName}` }
    </span>
);

Title.propTypes = {
    translate: PropTypes.func,
    record: PropTypes.object,
};

export default translate(Title);